import { FormInstance } from 'antd';
import { formatAmount } from './formatAmount';

type FieldValues = {
  downPayment?: number;
  purchasePrice?: number;
  propertyValue?: number;
  loanToValue?: number;
  purchasePriceActive?: boolean;
  calculateFromLoanToValue?: boolean;
}

export const calculateLoanAmount = (
  form: FormInstance,
  loanIndex: string | number,
  {
    downPayment,
    purchasePrice,
    propertyValue,
    loanToValue,
    purchasePriceActive,
    calculateFromLoanToValue
  }: FieldValues = {}
) => {
  const downPaymentValue = downPayment ??
    (parseFloat(form.getFieldValue(['loans', loanIndex, 'downPayment', 'value'])) || 0);

  const purchasePriceValue = purchasePrice ??
    (parseFloat(form.getFieldValue(['loans', loanIndex, 'purchasePrice', 'value'])) || 0);

  const propertyValueValue = propertyValue ??
    (parseFloat(form.getFieldValue(['loans', loanIndex, 'externalLoan', 'propertyValue'])) || 0);

  const loanToValueValue = loanToValue ??
    (parseFloat(form.getFieldValue(['loans', loanIndex, 'externalLoan', 'loanToValue'])) || 0);

  const purchasePriceActiveValue = purchasePriceActive ?? form.getFieldValue(['tableView', 'purchasePrice', 'active']);

  const price = purchasePriceActiveValue ? purchasePriceValue : propertyValueValue;

  if (calculateFromLoanToValue) {
    return parseFloat(formatAmount((loanToValueValue / 100) * price));
  }

  return parseFloat(formatAmount(price - downPaymentValue));
}
